"use strict";

import dispatcher from "./../dispatcher";
import {Collection} from "vwa/flux";
import poiStore from "./pois";
import filterGroups from "vwa/utils/filterGroups";

const pinnedPOIStore = new Collection();
export default pinnedPOIStore;

window.pinnedPOIStore = pinnedPOIStore;

poiStore.on('set', pois => {
	if (!pois){
		pinnedPOIStore.set(null);
	}
	else{
		pinnedPOIStore.insert( pois.map(e => e._id) );
	}
});

poiStore.on('insert', pois => {
	
	// amennyiben az �sszes poi fel van pinelve,
	// �gy felt�telezz�k, hogy ezt is fel akarjuk pinelni
	
	const numOfPOIs = filterGroups(poiStore.getAll()).length;
	const numOfPinnedPOIs = pinnedPOIStore.getAll().length;
	
	if (numOfPOIs == numOfPinnedPOIs + pois.length) {
		pinnedPOIStore.insert(pois.map(p => p._id));
	}
});

poiStore.on('remove', pois =>
	pinnedPOIStore.remove(pois.map(p => p._id))
);

dispatcher.on('pinPOIs', (poiIds, value) => {
	
	if (!poiIds)
		return;
	
	if (value == true)
		pinnedPOIStore.insert(poiIds);
	else
		pinnedPOIStore.remove(poiIds);
});


// WEBPACK FOOTER //
// ./src/store/pinnedPOIs.js